<template>
  <sea-page title="Reset password">
    <v-card max-width="500" class="mx-auto">
      <v-card-title>
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
              <span class="headline">Reset Password</span>
            </v-col>
            <v-col cols="12">
              <v-alert type="info" :value="!success">
                <span class="text-body-2 text-md-body-1">
                  Inserire lo username registrato nel sistema.
                </span>
              </v-alert>
              <v-alert type="success" :value="success">
                <span class="text-body-2 text-md-body-1">
                  Controlla la tua email per le istruzioni su come effettuare il
                  reset della password.
                </span>
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <form
        v-if="!success"
        name="form"
        role="form"
        @submit.prevent="requestReset()"
      >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="10" offset="1">
                <v-text-field
                  label="Username"
                  placeholder="Username"
                  type="text"
                  v-model="resetAccount.login"
                  required
                  :error-messages="errors"
                  @input="$v.resetAccount.login.$touch()"
                  @blur="$v.resetAccount.login.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            color="blue darken-1"
            text
            :disabled="$v.resetAccount.login.$invalid || success"
          >
            Reset
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </sea-page>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import mixin from "@/mixin";

export default {
  mixins: [mixin, validationMixin],
  validations: {
    resetAccount: {
      login: {
        required,
      },
    },
  },
  data() {
    return {
      success: null,
      error: null,
      resetAccount: {
        login: "",
      },
    };
  },
  methods: {
    requestReset() {
      this.$v.$touch();
      if (!this.$v.resetAccount.$invalid) {
        this.resetPasswordInit(this.resetAccount.login)
          .then(() => {
            this.success = true;
          })
          .catch(() => {
            this.success = false;
            this.error = true;
          });
      }
    },
    ...mapActions({
      resetPasswordInit: "account/resetPasswordInit",
    }),
  },
  computed: {
    errors() {
      const vals = [];
      if (!this.$v.resetAccount.login.$dirty) return vals;
      !this.$v.resetAccount.login.required && vals.push(this.locales.required);
      return vals;
    },
  },
};
</script>
